// import * as types from './type.js'
import Vue from "vue";
import utils from "@/utils/index";
import api from '@/api/baseUrl'
import "@vant/touch-emulator";
import { ImagePreview } from 'vant'
Vue.use(ImagePreview)
export default {
  async PriviewFile(
    { state, dispatch, commit },
    { filename, fileurl, file, siteId, isFairy, officeWebUrl, errorFn }
  ) {
    try {
      const format = await dispatch("getFileFormat", file);
      console.log("format", format);
      console.log("fileurl", fileurl);
      if (fileurl.indexOf("token") === -1) {
        fileurl = utils.formatUrlWstoken(fileurl);
      }
      console.log("fileurl", fileurl);
      switch (format) {
        case "doc":
        case "docx":
        case "xls":
        case "xlsx":
        case "ppt":
        case "pptx":
          if (state.imagePreview.show) {
            state.imagePreview.show = false;
          }
          if (!officeWebUrl) {
            window.open(fileurl)
            return false
          }
          commit("setProjection", {
            fileurl: `${officeWebUrl}/op/view.aspx?src=${fileurl}`,
            filename,
            mode: "office",
            show: true
          });
          break;
        case "pdf":
          console.log("preview pdf siteId", siteId);
          console.log("preview pdf baseUrl", api.baseurl);
          let viewUrl = ''
          if (siteId === 'scnu') {
            viewUrl = 'https://statics.scnu.edu.cn/api'
          } else if (siteId === 'smu') {
            viewUrl = api.baseurl
          }
          if (state.imagePreview.show) {
            state.imagePreview.show = false;
          }
          commit("setProjection", {
            fileurl: viewUrl ? `${viewUrl}/viewer/web/viewer2.html#${fileurl}` : fileurl,
            filename,
            mode: "pdf",
            show: true
          });
          break;
        case "jpg":
        case "png":
        case "gif":
        case "jpeg":
        case "svg":
          console.log("imagepreview", state.imagePreview);
          if (!isFairy) {
            commit("setProjection", {
              fileurl: "",
              filename: "",
              mode: "",
              show: false
            });
            ImagePreview({ images: [fileurl], closeable: true })
          } else {
            commit("setPreviewFiles", {
              fileurl,
              show: true
            });
          }
          break;
        case "mp4":
          if (state.imagePreview && state.imagePreview.close) {
            state.imagePreview.close();
          }
          commit("setProjection", { fileurl, filename, mode: "video", show: true });
          break;
        case "mp3":
          if (state.imagePreview && state.imagePreview.close) {
            state.imagePreview.close();
          }
          commit("setProjection", { fileurl, filename, mode: "audio", show: true });
          break;
        default:
          throw {
            code: "文件预览",
            msg: "请使用云课堂网页版预览文件" + filename
          };
      }
    } catch (error) {
      console.error(`Download file:`, error);
      Vue.prototype.$throw({ error, errorFn });
    }
  },
  getFileFormat({ state }, url) {
    const splitUrl = url.split(".");
    return splitUrl.length > 0
      ? splitUrl[splitUrl.length - 1].toLowerCase()
      : "";
  }
};
